<section class="content">
  <div class="card" style="padding: 24px;">
  <div class="container-fluid">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>Select Date</mat-label>
        <input type="date" [(ngModel)]="selected_date" class="main-border-class" />
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;">Get</button>
      </div>
    </div>
    <br>
    <div *ngIf="!is_document_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div *ngIf="is_document_available">
      <div class="table-responsive" >
        <div class="row">
          <div class="col-6"></div>
          <div class="col-6">
            <div class="row">
              <div class="col-4">
                <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50"
                  *ngIf="!is_document_available">
                </mat-progress-spinner>
              </div>
              <div class="col-4">
                <button mat-button class="button-class" (click)="downloadReportCliked()"><i class="material-icons">
                    picture_as_pdf
                  </i> Download report</button>
              </div>
              <div class="col-4">
                <button mat-button class="button-class"><i class="material-icons">
                    get_app
                  </i> Download Excel</button>
              </div>
            </div>
          </div>
        </div>
        <br>
        <!-- <object data="{{test_data}}"></object> -->
        <!-- <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Counter Name</th>
              <th>Card sales</th>
              <th>Agent Sales</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let counter of total_sale_details['counter_list']; let counter_index=index">
              <td>{{counter_index + 1}}</td>
              <td>{{counter['name']}}</td>
              <td style="text-align: right;">{{total_sale_details['icustomer_sale'][counter['id']] | currency: 'INR'}}</td>
              <td style="text-align: right;">{{total_sale_details['sale'][counter['id']] | currency: 'INR'}}</td>
              <td style="text-align: right;">
                {{total_sale_details['icustomer_sale'][counter['id']] + total_sale_details['sale'][counter['id']] | currency: 'INR'}}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: right;">Grand Total</td>
              <td style="text-align: right;">{{total_sale_details['icustomer_total_sale'] | currency: 'INR'}}</td>
              <td style="text-align: right;">{{total_sale_details['agent_total_sale'] | currency: 'INR'}}</td>
              <td style="text-align: right;">{{total_sale_details['grand_total'] | currency: 'INR'}}</td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </div>
  </div>
  </div>
  <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_details!== null"></iframe>
</section>
